import React from 'react';
import Modal from './Modal';
import './VideoPlayerModal.css';

const VideoPlayerModal = ({ video, isOpen, onClose }) => {
  if (!video) return null;

  const { embedUrl, videoUrl, videoType, title } = video;

  const renderPlayer = () => {
    switch (videoType) {
      case 'youtube':
      case 'vimeo':
      case 'unknown':
        return (
          <iframe
            src={embedUrl || videoUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="video-player-modal__iframe"
          />
        );
      case 'direct':
        return (
          <video
            controls
            className="video-player-modal__video"
            src={videoUrl}
            title={title}
          >
            Your browser does not support the video tag.
          </video>
        );
      default:
        return (
          <iframe
            src={embedUrl || videoUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="video-player-modal__iframe"
          />
        );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || 'Video Player'}
      size="xl"
      footer={
        <button className="btn btn-ghost" onClick={onClose}>
          Close
        </button>
      }
    >
      <div className="video-player-modal">
        <div className="video-player-modal__player">
          {renderPlayer()}
        </div>
        <div className="video-player-modal__info">
          <p>
            <strong>Video Type:</strong> {videoType}
          </p>
          <p>
            <strong>URL:</strong>{' '}
            <a href={videoUrl} target="_blank" rel="noopener noreferrer">
              {videoUrl}
            </a>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default VideoPlayerModal;